import { render } from "./CampaignsManagementDetail.vue?vue&type=template&id=21d15b4a"
import script from "./CampaignsManagementDetail.vue?vue&type=script&lang=js"
export * from "./CampaignsManagementDetail.vue?vue&type=script&lang=js"

import "./CampaignsManagementDetail.vue?vue&type=style&index=0&id=21d15b4a&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__